<template>
    <div v-if="bonus" class="bonus-rule">
        <ru v-if="lang == 'ru'" :bonus="bonus" />
        <fr v-else-if="lang == 'fr'" :bonus="bonus" />
        <es v-else-if="lang == 'es'" :bonus="bonus" />
        <en v-else :bonus="bonus" />
    </div>
</template>
<script>
import Vue from 'vue';

import Ru from './ru.vue';
import En from './en.vue';
import Fr from './fr.vue';
import Es from './es.vue';

export default {
    name: 'bonus-rules-deposit',
    components: { Ru, En, Fr, Es },
    props: {
        bonus: {
            type: Object,
            required: true
        }
    },
    computed: {
        lang() {
            return Vue.state.lang.currentLang;
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-deposit/index.vue